import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Space } from '../../../common';
import { ClickPreOrderButton, ClickQuickAndCollectButton } from '../Button';
import Layout, { Main } from '../Layout';
import { useLanguage } from '../../../../context/language/language';
import useDeliveryData from '../../../common/hook/useDeliveryData';
import {
  DELIVERY_ADDRESS,
  DELIVERY_TYPE_MENU
} from '../../../../constant/deliveryFlow';
import useResponsive from '../../../../utils/responsive';
import { deliverySelectionModalSize } from '../modalSize';
import { trackPageLoad } from '../../../../utils/adobeAnalytics';
import { trackClickSelectDeliveryType } from '../../../../utils/eventTracking';

function DeliveryMenu(props) {
  const word = useLanguage();
  const deliveryData = useDeliveryData();
  const { isMobile, isTablet } = useResponsive();

  useEffect(() => {
    trackPageLoad('Delivery Method');
  }, []);

  return (
    <Layout
      title={word('DeliveryAddress.Type.Options')}
      onClose={props.onClose}
      backButtonShown={false}
      bottomSpace={isMobile ? 24 : 0}
      width={isTablet ? deliverySelectionModalSize.tablet.width : deliverySelectionModalSize.desktop.width}
      height={isTablet ? deliverySelectionModalSize.tablet.height : deliverySelectionModalSize.desktop.height}
      isDefaultModalSize={false}
    >
      <Main>
        <Row>
          <ClickQuickAndCollectButton
            id="delivery-method-on-demand-btn"
            active={deliveryData.currentSetting.includes('OD') && deliveryData.formHadData}
            onClick={() => {
              props.onNext('OD', DELIVERY_ADDRESS);
              trackClickSelectDeliveryType('OD');
            }}
          />
          <Space line={0.8} />
          <ClickPreOrderButton
            id="delivery-method-schedule-for-later-btn"
            active={deliveryData.currentSetting.includes('SFL') && deliveryData.formHadData}
            onClick={() => {
              props.onNext('SFL', DELIVERY_TYPE_MENU);
              trackClickSelectDeliveryType('SFL');
            }}
          />
        </Row>
      </Main>
    </Layout>
  );
}

DeliveryMenu.propTypes = {
  onNext: PropTypes.func,
  onClose: PropTypes.func,
};

DeliveryMenu.defaultProps = {
  onNext: () => false,
  onClose: () => false,
};

export default DeliveryMenu;
